import OrganizationsAPI from '~/services/api/OrganizationsAPI';
import UserAPI from '~/services/api/UserAPI';
import {
  SET_DOCUMENTS_LOADING,
  SET_DOCUMENTS,
  SET_ME,
  SET_MEMBER_STATS,
} from '~/store/me/mutation-types';

export async function fetchMemberMe({ commit }) {
  try {
    const me = await UserAPI.fetchMembersMe();
    commit(SET_ME, me.data);
    return Promise.resolve(me.data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function fetchOrganizationDocuments({ commit }, id) {
  try {
    commit(SET_DOCUMENTS_LOADING, true);
    const documents = await OrganizationsAPI.getOrganizationDocument(id);
    const data = documents?.data ?? [];
    commit(SET_DOCUMENTS, data);
    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  } finally {
    commit(SET_DOCUMENTS_LOADING, false);
  }
}

export async function fetchMemberStats({ commit }) {
  try {
    const stats = await UserAPI.fetchMemberStats();
    commit(SET_MEMBER_STATS, stats);
    return Promise.resolve(true);
  } catch (error) {
    return Promise.reject(error);
  }
}
